<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Users List'}}</strong>
        </div>
        <div class="col-md-1">
          <download :tableId="'users'" :fileName="'users-list'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <input
              v-model="searchParams.name"
              class="form-control"
              name="search"
              placeholder="Search by Name/Email"
              @keyup="search"
            />
          </div>
        </div>
        <div class="col-md-7"></div>
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-2">
          <router-link :to="'/acl/add-user'" class="btn btn-sm btn-success pull-right">
            <i class="fa fa-plus"></i> Add User
          </router-link>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table id="users" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='name'">{{row['first_name']+' '+row['last_name']}}</span>
                <span v-else-if="field.name==='role'">{{userRoles[row['role']].value}}</span>
                <span
                  v-else-if="field.name==='trial_expiry'"
                >{{(row[field.name] && row[field.name] !=='')? getDate(row[field.name]): '-'}}</span>
                <span
                  v-else-if="field.name==='status'"
                >{{(row['status']===false)? 'Inactive':'Active'}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <span
                    v-for="(action, index) in actions"
                    v-bind:key="index+'-action-'+action.tooltip"
                  >
                    <a
                      v-if="(row.role===0 && action.type==='pin') || ( row.role===1 && action.type==='pin') || ( row.role===0 && action.type==='password') || ( row.role===1 && action.type==='password')"
                      style="margin:1px 4px"
                      class="btn btn-sm btn-small"
                      :class="action.btnClass"
                      @click.prevent="action.callback(row,index,$event)"
                    >
                      <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                    </a>
                    <a
                      v-else-if="action.type==='edit' || action.type=== 'portfolio'"
                      style="margin:1px 4px"
                      class="btn btn-sm btn-small"
                      :class="action.btnClass"
                      @click.prevent="action.callback(row,index,$event)"
                    >
                      <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                    </a>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages>1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li
              v-for="(page, index) in pages"
              v-bind:key="index+page"
              class="page-item"
              :class="(current_page == page)? 'active':''"
            >
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- </card> -->
    </div>
    <ChangePassword
      :show.sync="showChangePass"
      ref="changePassModal"
      v-bind:small="true"
      :user="userId"
      :cancelClass="'btn btn-secondary'"
    ></ChangePassword>
    <PinChange
      :show.sync="showChangePin"
      ref="changePinModal"
      v-bind:small="true"
      :user="userId"
      :cancelClass="'btn btn-secondary'"
    ></PinChange>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import PinChange from "@/components/PinChange.vue";
import ChangePassword from "@/components/ChangePassword.vue";
export default {
  components: { PinChange, ChangePassword },
  mixins: [commonMixins],
  name: "UserActivity",
  created() {
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "user/listing",
      apiMode: true,
      company: {},
      actions: [
        {
          btnClass: "btn-primary",
          icon: "fa-edit cwhite",
          callback: this.editUser,
          tooltip: "Edit user",
          type: "edit"
        },
        {
          btnClass: "btn-primary",
          icon: "fa-key cwhite",
          callback: this.showChangePassModal,
          tooltip: "Change Password",
          type: "password"
        },
        {
          btnClass: "btn-primary",
          icon: "fa-paperclip cwhite",
          callback: this.showChangePinModal,
          tooltip: "Change PIN",
          type: "pin"
        },
        {
          btnClass: "btn-info",
          icon: "fa-list cwhite",
          callback: this.getUserPortfolio,
          tooltip: "Portfolios",
          type: "portfolio"
        }
      ],
      tableFields: [
        // {
        //   name: "id",
        //   title: "ID"
        // },
        {
          name: "name",
          title: "User Name"
        },
        {
          name: "email",
          title: "Email"
        },
        {
          name: "mobile",
          title: "Mobile"
        },
        {
          name: "role",
          title: "Role"
        },
        {
          name: "trial_expiry",
          title: "Expiry Date"
        },
        {
          name: "status",
          title: "Status"
        }
      ],
      searchParams: { name: "" },
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      showChangePass: false,
      showChangePin: false,
      userId: 0,
      userRoles: [
        { id: 0, value: "Super Admin" },
        { id: 1, value: "Admin" },
        { id: 2, value: "Premium User" },
        { id: 3, value: "Free User" },
      ]
    };
  },
  methods: {
    search() {
      console.log(this.searchParams);
      if (this.searchParams.name.length > 2) {
        this.fetchData(this.searchParams);
      }
      if (this.searchParams.name.length === 0) {
        console.log("Reset");
        this.reset();
      } else {
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    reset() {
      // window.location.reload();
      // this.$router.push({ name: "user-listing" });
      this.searchParams = { name: "" };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl; // + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data ? {} : {};
        const name =
          this.searchParams.name && this.searchParams.name === ""
            ? 0
            : this.searchParams.name;
        console.log("name", name);
        http.get(this.url + "/name=" + name, params, function(error, response) {
          console.log(response);
          if (response.responseType === "success") {
            myself.fillableData = response.data;
            myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            myself.prevDisabled = myself.pageToLoad == 1;
            myself.nextDisabled = myself.current_page == myself.totalPages;
            myself.isLoading = false;
            // set 5 pages to show
            console.log("current", myself.current_page);
            let i = 5;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            console.log("PAges", myself.pages);
          } else {
            console.log(error);
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    editUser(row, index, $event) {
      console.log(row, index, $event);
      this.$router.push({
        name: "edit-user",
        params: { id: row.id }
      });
    },
    showChangePinModal(row, index, $event) {
      this.userId = parseInt(row.id);
      this.$refs.changePinModal.open();
    },
    showChangePassModal(row, index, $event) {
      this.userId = parseInt(row.id);
      this.$refs.changePassModal.open();
    },
    getUserPortfolio(row) {
      this.$router.push({
        name: "user-portfolios",
        params: { id: row.id, user: row }
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/users.vue